import { render } from "./ClaseSiCategorii.vue?vue&type=template&id=0f92a1ee&scoped=true&ts=true"
import script from "./ClaseSiCategorii.vue?vue&type=script&lang=ts"
export * from "./ClaseSiCategorii.vue?vue&type=script&lang=ts"

import "./ClaseSiCategorii.vue?vue&type=style&index=0&id=0f92a1ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f92a1ee"]])

export default __exports__